import React, { useMemo, forwardRef } from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { ErrorBoundary } from 'react-error-boundary'
import clsx from 'clsx'
import { allowedFieldTypes, useDitto } from '@ow/ditto-core'
import { get, isArray } from 'lodash-es'
import Render from '../../../renders/block-renders'
import FieldErrorFallback from '../FieldErrorFallback'
import Field from '../field'

const StyledFields = styled.div`
  grid-template-columns: ${({ cols }) => `repeat(${cols}, minmax(0, 1fr))`};
  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .title {
    font-size: 16px;
  }
  ${tw`grid`}
`

const isNull = (data, defs) => {
  if (['ref', 'refMultiple'].includes(defs.type)) {
    return false
  }
  if (defs && defs.markFlag) {
    return false
  }
  if (data === false || data === 0) {
    return false
  }

  if (data && isArray(data) && data.length === 0) {
    return false
  }

  if (data) {
    return false
  }
  return true
}
const renderErrorTip = ({ opts, error }) => {
  return <FieldErrorFallback opts={opts} error={error} />
}
const Fields = function (
  {
    data,
    formControl,
    layout,
    fields,
    editableFields,
    widgets,
    waterMarkDefs,
    detailData,
    isHiddenMedia,
    refConditonFields,
  },
  ref
) {
  const { beforeTransform, onFetchRemoteData } = useDitto()
  const beforeTransformHook = beforeTransform ? beforeTransform() : null
  const { control, unregister, formState } = formControl || {}
  const editableSlugs = editableFields.map((v) => v.slug)

  const fieldsMap = useMemo(() => {
    const obj = {}
    fields.forEach((field) => {
      const editableField = editableFields.find((v) => v.slug === field.slug)
      if (editableField) {
        obj[field.slug] = editableField
      } else {
        obj[field.slug] = field
      }
    })
    return obj
  }, [editableSlugs, editableFields])

  return (
    <StyledFields
      cols={layout.cols}
      rows={layout.rows}
      className="gap-4"
      ref={ref}
    >
      {layout.children.map((field) => {
        const detailProps = {}
        const editorProps = {}

        const defs = fieldsMap[field.slug]
        const isFile =
          defs && (defs.type === 'media' || defs.type === 'attachment')
        if (field.layouts && defs.type === 'ref') {
          editorProps.layouts = field.layouts
          detailProps.layouts = field.layouts
          console.log(detailProps, 'detailProps')
        }

        if (field.opts) {
          editorProps.fieldOpts = field.opts
          detailProps.fieldOpts = field.opts
        }

        if (defs && isNull(data && data[defs.slug], defs)) {
          detailProps.type = 'text'
        }

        if (
          !defs ||
          (!allowedFieldTypes.includes(defs.type) &&
            editableSlugs.includes(defs.slug))
        ) {
          return null
        }
        if (
          isHiddenMedia &&
          !editableSlugs.includes(defs.slug) &&
          defs.type === 'media'
        ) {
          return null
        }

        return (
          <div key={defs.slug} className="flex flex-col gap-1">
            <ErrorBoundary
              FallbackComponent={(error) =>
                renderErrorTip({ error, opts: defs })
              }
            >
              {!editableSlugs.includes(defs.slug) && data ? (
                <>
                  {!field.layouts && (
                    <div className="w-full title">
                      {get(field, 'title', defs.title)}
                    </div>
                  )}
                  <div
                    className={clsx(isFile && 'flex items-center')}
                    style={{
                      color: 'rgba(0,0,0,0.60)',
                      fontSize: '16px',
                      height: defs.type === 'statistics' && '900px',
                    }}
                  >
                    <Render
                      value={
                        isNull(data[defs.slug], defs)
                          ? '暂无数据'
                          : data[defs.slug]
                      }
                      hooks={{
                        onFetchRemoteData,
                        beforeTransform: beforeTransformHook,
                      }}
                      defs={{ ...defs, ...detailProps }}
                      rowData={data}
                      fields={fields}
                      className={clsx(
                        'w-full flex flex-wrap items-center break-all gap-1',
                        isFile && 'gap-2',
                        defs.type === 'statistics' && 'h-full'
                      )}
                      detailData={detailData}
                    />
                  </div>
                </>
              ) : (
                <Field
                  opts={{ ...defs, ...editorProps }}
                  fields={fields}
                  error={formState.errors[defs.slug]}
                  errors={formState.errors}
                  control={control}
                  unregister={unregister}
                  formControl={formControl}
                  key={defs.slug}
                  widgets={widgets}
                  data={data}
                  detailData={detailData} // 其实就是data
                  refConditonFields={refConditonFields}
                  waterMarkDefs={waterMarkDefs}
                />
              )}
            </ErrorBoundary>
          </div>
        )
      })}
    </StyledFields>
  )
}

export default forwardRef(Fields)
